var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSelect, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FieldDuration } from 'fable/fieldDuration';
import { durationConverter } from 'utils/duration';
import { HideStrategy } from '../types';
import styles from './hidestrategy.module.scss';
class HideStrategyModal extends Component {
    isHideStrategyNode(node) {
        return node.nodeType !== 'action';
    }
    getPayload(strategy, ewtThreshold) {
        const { node } = this.props;
        const shownNodeId = this.isHideStrategyNode(node)
            ? node.payload.shownNodeId
            : uuid();
        const hiddenNodeId = this.isHideStrategyNode(node) &&
            node.payload.strategy !== HideStrategy.NEVER
            ? node.payload.hiddenNodeId
            : uuid();
        switch (strategy) {
            case HideStrategy.NEVER:
                return {
                    strategy,
                    shownNodeId,
                };
            case HideStrategy.EXPECTED_WAITING_TIME:
                return {
                    strategy,
                    shownNodeId,
                    hiddenNodeId,
                    ewtThreshold: durationConverter.seconds.toMilliseconds(ewtThreshold),
                };
            case HideStrategy.ALL_AGENTS_AWAY:
            case HideStrategy.ALL_AGENTS_OFFLINE:
            default:
                return {
                    strategy,
                    shownNodeId,
                    hiddenNodeId,
                };
        }
    }
    handleSaveClick(values) {
        // The form starts out with a null value, the form validates it to not be null.
        // But because it's a possible value according to the type, we rule it out first.
        if (values.strategy === null)
            return;
        const { node } = this.props;
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.HIDE_STRATEGY, payload: this.getPayload(values.strategy, values.ewtThreshold), overlay: [], text: '' });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    closeModal() {
        const { destroy, triggerClose } = this.props;
        destroy();
        triggerClose();
    }
    validateStrategy(strategy) {
        if (strategy === null) {
            return 'Must pick a hide strategy';
        }
        return undefined;
    }
    validateDuration(duration) {
        if (duration >= durationConverter.days.toSeconds(1)) {
            return 'Must be 1 day or less';
        }
        if (duration <= 0) {
            return 'Must be at least 1 second';
        }
        return undefined;
    }
    render() {
        const { handleSubmit, hidestrategyValues, node, nodeLabel, selectedStrategy, } = this.props;
        return (_jsx("div", Object.assign({ className: "queue modal-chatflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: "Hide strategy is used to decide how the widget functions when all agents are offline and/or away. We recommend that you only use 'Never hide' if you also use a contact form." })), _jsxs(ModalBody, { children: [_jsx(Field, { label: "Hide strategy", placeholder: "Please select a hide strategy", name: "strategy", validate: this.validateStrategy, component: FieldSelect, items: hidestrategyValues, required: true }), selectedStrategy === HideStrategy.EXPECTED_WAITING_TIME && (_jsx(Field, { component: FieldDuration, name: "ewtThreshold", label: "EWT Threshold", className: styles.duration, includeDays: false, validate: this.validateDuration, required: true }))] }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], HideStrategyModal.prototype, "getPayload", null);
__decorate([
    boundMethod
], HideStrategyModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], HideStrategyModal.prototype, "closeModal", null);
export default reduxForm({
    form: 'chatFlowHideStrategyForm',
    enableReinitialize: true,
})(HideStrategyModal);
